<template>
  <div>
    <div class="containerTop">
        <a-steps :current="current">
       <a-step title="第二步" />
       <a-step title="第二步" />
       <a-step title="第三步" />
    </a-steps>
    <div class="cotainerCenter">
        <div v-if="type==0">
            <div>
                <span>基本信息</span>
            </div>
         <a-form-model :model="categories" ref="categoriesRef" >
        <a-row>
          <a-col :span="12">
            <a-form-model-item  :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="企业名称" prop="companyName">
              <span>{{  }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }" label="企业地址" prop="companyName">
              <span>{{ }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }" label="选择项目"  prop="categoryName"
                :rules="{
                  required: true,
                  message: '请选择项目名称',
                  trigger: 'change',
                }"
              >
                <a-select allowClear placeholder="请选择项目" v-model="informationList.categoryName"  @change="" >
                  <!-- <a-select-option :value="item.id" v-for="(item, index) in categoryNameList" :key="index" >
                    {{ item.categoryName }}
                  </a-select-option> -->
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }" label="选择子项目" prop="projectCategory"
                :rules="{
                  required: true,
                  message: '请选择子项目',
                  trigger: 'change',
                }"
              >
                <a-select  mode="multiple" allowClear placeholder="请选择子项目"  v-model="informationList.projectCategory" @change="">
                  <!-- <a-select-option :value="item.id" v-for="(item, index) in datalist" :key="index">
                    {{ item.abbreviationCategory }}
                  </a-select-option> -->
                </a-select>
              </a-form-model-item>
            </a-col>
           
          </a-row>
          <a-row>
             <a-col :span="12">
              <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="行业"  prop="industryName"
                :rules="{
                  required: true,
                  message: '请输入行业',
                  trigger: 'change',
                }"
              >
                <a-select allowClear placeholder="所属行业" v-model="informationList.industryName" @change="">
                  <!-- <a-select-option :value="item.id" v-for="(item, index) in industryList" :key="index">
                    {{ item.industryName }}
                  </a-select-option> -->
                </a-select>
              </a-form-model-item>
            </a-col>
              <a-col :span="12">
              <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="选择行业子类"  prop="industryName"
                :rules="{
                  required: true,
                  message: '请选择行业子类',
                  trigger: 'change',
                }"
              >
                <a-select allowClear placeholder="选择行业子类" v-model="informationList.industryName" @change="">
                  <!-- <a-select-option :value="item.id" v-for="(item, index) in industryList" :key="index">
                    {{ item.industryName }}
                  </a-select-option> -->
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
         </a-form-model>
        </div>
        <div v-else-if="type==1">
            <div>
               <span>环境监测</span>
            </div>
            <div>
                 <div>
                    <a-button type="primary" @click="" style="margin-right: 5px">新增点位</a-button>
                 </div>
                 <a-table :data-source="environmentList" bordered :loading="loading" :pagination="false" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }" >
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                    <template scope="text, record, index">
                    {{index + 1 }}
                    </template>
                </a-table-column>
                <a-table-column key="factorName" title="检测点位" ellipsis="true" data-index="factorName" />
                <a-table-column key="factorName" title="污染物" ellipsis="true" data-index="factorName" />
                <a-table-column key="factorName" title="价格" ellipsis="true" data-index="factorName" />
                 <a-table-column title="操作" width="220px" v-if="number == 0">
                    <template scope="text,record">
                        <a @click="editRelevance(record)">编辑</a>
                    </template>
                 </a-table-column>
                </a-table>
             <div>
                 <a-form-model :model="categories" ref="categoriesRef" >
                    <a-row>
                         <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="检测费"  prop="industryName" >
                             </a-form-model-item>
                         </a-col>
                         <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="报告编制费"  prop="industryName"
                             :rules="{
                             required: true,
                             message: '请填写报告编制费',
                             trigger: 'change',
                            }" >
               
                             </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="专家评审费"  prop="industryName"
                             :rules="{
                             required: true,
                             message: '请填写专家评审费',
                             trigger: 'change',
                            }" >
               
                             </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                         <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="合计"  prop="industryName" >
               
                             </a-form-model-item>
                        </a-col>
                    </a-row>
                 </a-form-model>
                 </div>
                

            </div>
        </div>
        <div v-else-if="type==2">
           <!-- <a-button type="primary" @click="click" style="margin-right: 5px">新增大类</a-button> -->
          
          <Quoteprice></Quoteprice>
          
        </div>
    </div>
        <a-button key="submit" type="primary" :loading="loading" @click="previous" >上一步</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="next">下一步</a-button>
    </div>
    
  </div>
</template>

<script>
import Quoteprice from '../generateQuotation/quoteprice'
import {computeLen}from '@/utils/amount'
export default {
  components: {
    Quoteprice

  },
    data() {
        return {
            current: 0,
            type: 0,
            informationList: {},
            environmentList: [],
            scroll_y: 150,
            num: 0
        }
    },
   methods: {
    previous() {
        this.current--
        this.type--
    },
    next() {
         this.current++
        this.type++

    }
   }

}
</script>

<style>

</style>